import { Params } from '@angular/router';
import { environment } from '@env/environment';

const equal = <T>(list: T[], key: keyof T, value: T[typeof key]): T[] => {
  const result = list.filter((item: T) => {
    return item[key] === value;
  });
  return result;
};

const notEqual = <T>(list: T[], key: keyof T, value: T[typeof key]): T[] => {
  const result = list.filter((item: T) => {
    return item[key] !== value;
  });
  return result;
};

export { equal, notEqual };

/**
 * 形式 金額
 * @param amount
 * @returns string Example: formatMoney(5500000) => Output: 5,500,000
 */
export function formatAmount(amount?: number): string {
  return amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') ?? '';
}

/**
 * 形式 表示量
 * @param data
 * @returns Array<string>
 */
export function formatDisplayAmount(data: any[]): Array<string> {
  let amounts: Array<string> = [];
  for (const item of data) {
    if (item?.currencyCode && item?.value) {
      amounts.push(`${item?.currencyCode} ${formatAmount(item?.value)}`);
    }
  }
  return amounts;
}

export function navigateToAnotherApp(app: string, destination: string, params?: Params) {
  let url = `${window.location.origin}${environment.spa.baseUrl}${app}/${destination}`;

  if (params) {
    url += '?' + new URLSearchParams(params).toString();
  }
  window.open(url, '_self');
}

export function navigateFormAction(url: string, method: 'GET' | 'POST' = 'GET', params?: Params) {
  const form = document.createElement('form');
  form.method = method;
  form.action = url; // URL to send the POST request to
  form.target = '_blank'; // Open in a new tab

  for (const [key, value] of Object.entries(params ?? {})) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  }

  // Append the form to the body and submit it
  document.body.appendChild(form);
  form.submit();

  // Clean up by removing the form from the document
  document.body.removeChild(form);
}
